import { getAuthSignatureApi } from './api'
import CWTracks from '@channelwill/tracks'
export function initCWTracks(storeDomain: string = '', installTime: string = '') {
    const dsn = `${process.env.PUBLIC_CHANNELWILL_DSN}/affiliate`
    CWTracks.init({
        dsn,
        appStoreUrl: 'https://apps.shopify.com/seo-master',
        getAuthSignature: getAuthSignatureApi,
        app_id: '518111167165693952',
        shop: storeDomain,
        installTime, // 用户首次安装时间 例如：2026-02-02T00:00:00+08:00 或1773832852 秒级别时间戳 
        appHost: process.env.PUBLIC_CHANNELWILL_HANDLE,
    })
}